import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box, Typography } from '@material-ui/core';
import '../styles/loadingState.css';

interface LoadingStateProps {
  open: boolean;
  primaryText: string;
  secondaryText?: string;
}

// Backdrop overlay covering an entire tab section while an operation is in flight.
export default function LoadingState({
  open,
  primaryText,
  secondaryText,
}: LoadingStateProps) {
  return (
    <Backdrop
      open={open}
      className="ec-trigger-overlay"
      style={{
        position: 'absolute',
        zIndex: 10,
        borderRadius: 'inherit',
      }}
    >
      <Box className="ec-trigger-overlay-state">
        <CircularProgress color="primary" size={40} />
        <Typography className="ec-trigger-overlay-primary">
          {primaryText}
        </Typography>
        {secondaryText && (
          <Typography className="ec-trigger-overlay-secondary">
            {secondaryText}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
}
